import React from 'react'
import { FaAngleRight } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

const ProfileIntiationLablesContainer = ({icon, iconBackgroundColor, title, description, status, isActionRequired, navigation, actionName}) => {
    const navigate = useNavigate();
    return (
        status === "COMPLETED" || status === "AWAIT" ?
        <div className="status-quick-action-container"> 
          <div className="dashbaord-quick-action-container-left">
              <img
                loading="lazy"
                alt="icon"
                srcSet={icon}
                className="shrink-0 rounded-lg aspect-[1.02] w-[45px]"
                style={{ height: '50px', padding: '10px', backgroundColor: iconBackgroundColor }}
              />
              <div className="flex flex-col my-auto">
                    <div className="medium-size-text">
                      {title}
                    </div>
                    <div className="small-size-text">
                      {description}
                    </div>
              </div>
              </div>
              {isActionRequired && (
  status === "COMPLETED" ? 
  <div className="continue" style={{ color:'#0094DC'}}>Completed</div> : 
  <FaAngleRight/>
)}
              </div>
    :
    <div className="status-quick-action-container"> 
        <div className="dashbaord-quick-action-container-left">
                <img
                  loading="lazy"
                  alt="icon"
                  srcSet={icon}
                  className="shrink-0 rounded-lg aspect-[1.02] w-[45px]"
                  style={{ height: '50px', padding: '10px', backgroundColor: iconBackgroundColor }}
                />
                <div className="flex flex-col my-auto">
                      <div className="medium-size-text">
                      {title}
                      </div>
                      <div className="small-size-text">
                      {description}
                      </div>
                </div>
              </div>
              {isActionRequired && (
 <div className="dashboard-intialisation-continue-action-btn" onClick={() => navigate(navigation)}>
 {actionName}
</div>
)}
              
          </div>
      );
    };
    

export default ProfileIntiationLablesContainer
